import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setSearchFormData } from '@/redux/actions/searchFormDataActions';

export const useGuestSelected = () => {
  const searchFormData = useSelector((state) => state.searchFormData);
  const userData = useSelector((state) => state.user);
  const guestArray = searchFormData?.guests;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [selectedCount, setSelectedCount] = useState(guestArray.length);

  const [guests, setGuests] = useState(
    guestArray.length === 0
      ? [
          {
            id: 1,
            firstName: userData?.name,
            lastName: userData?.lastName,
            email: userData?.email,
            isDefault: true,
            isSelected: false,
          },
        ]
      : guestArray,
  );

  const dispatch = useDispatch();
  const currentSearchFormData = useSelector((state) => state.searchFormData);

  const addGuest = (guestData) => {
    const newGuest = {
      id: Date.now(),
      ...guestData,
      isDefault: false,
      isSelected: false,
    };

    setGuests((prevGuests) => [...prevGuests, newGuest]);
    setShowForm(false);
    return newGuest;
  };

  const selectGuest = (guestId) => {
    const updatedGuests = guests.map((guest) => {
      if (guest.id === guestId) {
        const newSelectedState = !guest.isSelected;
        setSelectedCount((prevCount) => (newSelectedState ? prevCount + 1 : prevCount - 1));
        return { ...guest, isSelected: newSelectedState };
      }
      return guest;
    });
  
    const guestsForRedux = updatedGuests.filter((guest) => guest.isSelected);
  
    setGuests(updatedGuests);
    dispatch(
      setSearchFormData({
        ...currentSearchFormData,
        guests: guestsForRedux, 
      }),
    );
  };

  const showGuestForm = () => {
    setShowForm(true);
  };

  const hideGuestForm = () => {
    setShowForm(false);
  };

  const getSelectedGuests = () => {
    return guests.filter((guest) => guest.isSelected);
  };

  return {
    loading,
    error,
    showForm,
    guests,
    selectedCount,
    addGuest,
    selectGuest,
    showGuestForm,
    hideGuestForm,
    setError,
    setLoading,
    getSelectedGuests,
  };
};
